import { observer } from 'mobx-react-lite';
import CommonButton from '../../../../components/common-components/button/CommonButton';
import Popup from '../../../../components/common-components/pop-up/Popup';

interface DeleteConfirmationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message?: string;
}

const DeleteConfirmationDialog = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message = 'Bu işlemi geri alamazsınız.',
}: DeleteConfirmationDialogProps) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Popup
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      footer={
        <>
          <CommonButton type="cancel" onClick={onClose}>
            İptal
          </CommonButton>
          <CommonButton type="delete" onClick={handleConfirm}>
            Sil
          </CommonButton>
        </>
      }
    >
      <div style={{ padding: '20px 0' }}>
        <p style={{ margin: 0, color: '#dc2626', fontWeight: 'bold', lineHeight: '1.5' }}>
          {message}
        </p>
      </div>
    </Popup>
  );
};

export default observer(DeleteConfirmationDialog);
